import { render } from "./Home.vue?vue&type=template&id=1c0dbd81&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=1c0dbd81&lang=scss&scoped=true"
import "./Home.vue?vue&type=style&index=1&id=1c0dbd81&lang=scss"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0dbd81"]])

export default __exports__